import "./pms.css";
import { Link } from "react-router-dom";
import React, { useState, useEffect, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import men from "../images/men.png";
import Mobilemen from "../images/mobile-men.png";
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";
import ready from "../images/avc-ready.jpg";
import benefits from "../images/avc-benefits.jpg";
import pmsBanner from "../images/pms-banner.jpg";
import pmsWorks from "../images/pms-works.png";
import pmsStart from "../images/pms-start.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import Footer from "./footer";
import AOS from 'aos';

const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://pensure-cms.inspireleadership.biz/graphql",
  }),
  cache: new InMemoryCache(),
});

const Pms = () => {
 

  const [heroBanner, setHeroBanner] = useState([]);
  const [heroMobile, setHeroMobile] = useState([]);
  const [listSections, setListSections] = useState([]);
  const [businessSections, setBusinessSections] = useState([]);

               useEffect( () => {
                     AOS.init({
                          offset: 0,
                          duration: 1000,
                          once: true
                            });
                           }, [])
  

  useEffect(() => {

     window.scrollTo(0, 0);
    client
      .query({
        query: gql`
          query NewQuery {
            pages(first: 100) {
              edges {
                node {
                  pms {
                    listSection {
                      heading
                      caption
                      image {
                        mediaItemUrl
                      }
                      list {
                        item
                      }
                    }
                    heromobile {
                      heading
                      image {
                        mediaItemUrl
                      }
                      caption
                      buttonName
                      buttonLink
                    }
                    hero {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                    section {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                  }
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result);
        setHeroBanner(result.data.pages.edges[18].node.pms.hero);
        setHeroMobile(result.data.pages.edges[18].node.pms.heromobile);
        setListSections(result.data.pages.edges[18].node.pms.listSection);
        setBusinessSections(result.data.pages.edges[18].node.pms.section);
      });
  }, []);

  let listSectionsDisplay;

  let heroBannerDisplay;
  let heroMobileBannerDisplay;

  let businessSectionsDisplay;

  if (heroBanner.length > 0) {
    heroBannerDisplay = heroBanner.map((banner, i) => (
      <div className="pms-cover">
        <img className="pms-bg" src={banner.image.mediaItemUrl} />
        <div className="pms-content">
          <div className="pms-txt">
            <h1 className="pms-h1" data-aos="zoom-in" data-aos-delay="200">{banner.heading}</h1>
            <p className="grey-p-pms" data-aos="fade-up" data-aos-delay="200">{banner.caption}</p>
            <a href={banner.buttonLink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (heroMobile.length > 0) {
    heroMobileBannerDisplay = heroMobile.map((banner, i) => (
      <div className="pms-cover">
        <img className="pms-bg" src={banner.image.mediaItemUrl} />
        <div className="pms-content">
          <div className="pms-txt">
            <h1 className="pms-h1" data-aos="zoom-in" data-aos-delay="200">{banner.heading}</h1>
            <p className="grey-p-pms" data-aos="fade-up" data-aos-delay="200">{banner.caption}</p>
            <a href={banner.buttonLink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (listSections.length > 0) {
    listSectionsDisplay = listSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="d-flex d-none d-sm-block justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>

          <div className="pension-div1 pb-5">
            <h3 className="rma-h3 pb-5" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>

            <p
              className="grey-p-pms  pb-4 "
              style={{ color: "#3B475A", width: "470px" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <hr
              className="btm-bdr"
              style={{ borderTop: "none", width: "600px" }}
            />

            <ul
              className="pt-5 custom-square"
              style={{ listStyleType: "square", paddingLeft: "20px" }}
            >
              {section.list.map((items, i) => (
                <li className="grey-p-rma pt-4" style={{ color: "#3B475A" }} data-aos="fade-up" data-aos-delay="200">
                  {items.item}
                </li>
              ))}
            </ul>
          </div>

          <div className="d-flex d-block d-sm-none justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between pb-5 z-value"
        >
          <div className="pension-div1 pb-5">
            <h3 className="rma-h3 pb-5" data-aos="fade-up" data-aos-delay="200">{section.heading}</h3>

            <p
              className="grey-p-pms  pb-4 "
              style={{ color: "#3B475A", width: "470px" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <hr
              className="btm-bdr"
              style={{ borderTop: "none", width: "600px" }}
            />

            <ul
              className="pt-5 custom-square"
              style={{ listStyleType: "square", paddingLeft: "20px" }}
            >
              {section.list.map((items, i) => (
                <li className="grey-p-rma pt-4" style={{ color: "#3B475A" }} data-aos="fade-up" data-aos-delay="200">
                  {items.item}
                </li>
              ))}
            </ul>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ),
    );
  }

  if (businessSections.length > 0) {
    businessSectionsDisplay = businessSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="values compact-section">
            <h3 className="h3 rsa-h3" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <a
              class="open-acc-btn grey-p mt-3"
              href={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
              
            
            >
              {section.buttonName}
              <FontAwesomeIcon className="rsa-dwn-arr" icon={faArrowRight} />
            </a>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className="pms-div d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="pms-img-div d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>

          <div className="values-pms">
            <h3 className="h3 rsa-h3" data-aos="fade-up" data-aos-delay="200">{section.heading} </h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <a
              class="open-acc-btn grey-p mt-3"
              href={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
            
            >
              {section.buttonName}{" "}
              <FontAwesomeIcon className="rsa-dwn-arr" icon={faArrowRight} />
            </a>
          </div>
        </div>
      ),
    );
  }

  return (
    <>
      <div className="pms-container d-block d-sm-none">{heroBannerDisplay}</div>

      <div className="pms-container d-none d-sm-block">
        {heroMobileBannerDisplay}
      </div>

      <div className="containeer padding-section-standard-top">
        {listSectionsDisplay}

        {businessSectionsDisplay}
      </div>
              <Footer/>
           <div className='height-prod'> 

              </div>
    </>
  );
};

export default Pms;
